import React from "react";
import {Divider} from "../../../../designSystem/components/Divider";
import {SystemInformationRow} from "../SystemInfomationRow";
import {SYSTEM_INFO_ITEMS} from "../../model/systemInfo";

export const SystemInfoFeature = () => (
  <div className="w-full md:w-[400px] max-w-full bg-white rounded-lg m-auto">
    {SYSTEM_INFO_ITEMS.map(item => (
      <React.Fragment key={item.title}>
        <SystemInformationRow
          title={item.title}
          content={item.content}
        />
        <Divider />
      </React.Fragment>
    ))}
  </div>
)
